import { Navigate, Outlet } from 'react-router-dom'
import { DASHBOARD_AUTH_PATHS } from '@yourownmetric/shared'

import { useAppSelector } from '@/app/hooks'

export function RequireAuth() {
    const token = useAppSelector(s => s.auth.token)

    if (!token) {
        return <Navigate to={DASHBOARD_AUTH_PATHS.login} replace />
    }

    return <Outlet />
}
